import { LAG_GS }      from 'AppConfig/Config';
import React           from 'react';
import { useSelector } from 'react-redux';
import {
  getDePseudonymed,
  getDePseudonymedResultIds,
  userContainsRole
}                      from 'Redux/Query';

export const Pseudonym = ({ value, record }) => {
  const dePseudonymedResultIds = useSelector(getDePseudonymedResultIds);
  const dePseudonymed = useSelector(getDePseudonymed);
  const checkUserRole = useSelector(userContainsRole);

  if((dePseudonymed.includes(record.pseudonym?.key) || dePseudonymedResultIds.includes(record.id)) && checkUserRole( [ LAG_GS ])) {
    return (
      <React.Fragment>
        { (record.pseudonym) ? record.pseudonym.key : <i>---</i> }<br />
        <div className="dePseudonymed">
          { record.careProvider.name } <br />
          { record.careProvider.identNumber }
          {(record.careProvider.destinationKey) ? <React.Fragment><br />{ `(${record.careProvider.destinationKey})` }</React.Fragment> : '' }
        </div>
      </React.Fragment>
    )
  }
  return (record.pseudonym) ? record.pseudonym.key : <i>---</i>;
};
